import { render, staticRenderFns } from "./LoadingOverlay.vue?vue&type=template&id=64ec0ae9"
var script = {}
import style0 from "./LoadingOverlay.vue?vue&type=style&index=0&id=64ec0ae9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports